var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 76,
    viewBox: "0 0 210 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 210,
    height: 76,
    transform: "translate(136 35)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-136 -35)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_8",
    "data-name": "Groupe 8",
    transform: "translate(117.444 16.87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(20.556 32.749)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1",
    "data-name": "Groupe 1",
    transform: "translate(0 20.317)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M60.123,54.95a9.391,9.391,0,0,1-5.761,2.479q-3.248,0-5.945-3.61-2.045-2.7-5.872-12.691A2.954,2.954,0,0,0,42.4,40.8q-.073-.218-.109-.364-.439.694-2.553,4.084-2.191,4.415-3.428,6.492a12.105,12.105,0,0,1-3.939,3.975A6.928,6.928,0,0,1,28.5,56.081a9.641,9.641,0,0,1-1.168-.075,7.316,7.316,0,0,1-4.668-2.224,16.982,16.982,0,0,1-2.113-2.953c3.907,7.9,13.281,11.247,24.238,11.247,14.463,0,26.189-5.809,26.189-20.274A26.168,26.168,0,0,0,70.3,35.93q-1.012,3.6-1.967,6.147Q64.937,51.009,60.123,54.95Z",
    transform: "translate(-20.556 -35.93)",
    fill: "#16acc8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(2.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M28.173,58.169q1.239-2.369,2.408-4.814a37.263,37.263,0,0,1,5.286-7.442,8.479,8.479,0,0,1,3.9-2.333,7.581,7.581,0,0,1,2.26-.364,5.86,5.86,0,0,1,2.26.436,8.119,8.119,0,0,1,4.45,4.816,35.154,35.154,0,0,1,1.131,3.353l1.86,5.29q.618,1.494.947,2.224.436,1.021,1.022,1.02,1.054,0,2.626-3.208A116.007,116.007,0,0,0,63.4,35.96a2.068,2.068,0,0,1,.275-.646,26.18,26.18,0,0,0-41.9,2.2q1.5,16.634,5.123,21.82Q27.554,59.3,28.173,58.169Z",
    transform: "translate(-21.774 -25.872)",
    fill: "#16acc8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M50.071,33.311A2.574,2.574,0,0,1,51.6,31.305a5.274,5.274,0,0,1,2.7-.656h.182a5.012,5.012,0,0,1,2.735.693,1.963,1.963,0,0,1,1.058,1.713v.257Q56.051,52.824,55,60.189A2.676,2.676,0,0,1,53.428,62.2a6.179,6.179,0,0,1-2.919.656,5.491,5.491,0,0,1-2.735-.693,1.92,1.92,0,0,1-1.02-1.642,1.284,1.284,0,0,1,.036-.329Q47.848,52.823,50.071,33.311Z",
    transform: "translate(26.721 11.749)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4",
    "data-name": "Trac\\xE9 4",
    d: "M57.741,26.468a3.531,3.531,0,0,1-.073.693c-.024.17-.073.4-.145.693a4.609,4.609,0,0,1-.145.656q-.258,1.242-2.151,1.715a6.633,6.633,0,0,1-1.788.255,5.59,5.59,0,0,1-1.095-.109q-2.918-.548-2.919-2.553a4.152,4.152,0,0,1,.075-.729c.024-.17.059-.388.109-.656.073-.339.121-.56.145-.656q.255-1.239,2.151-1.749a7.425,7.425,0,0,1,1.751-.22,5.775,5.775,0,0,1,1.131.109Q57.742,24.427,57.741,26.468Z",
    transform: "translate(29.445 4.769)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_5",
    "data-name": "Trac\\xE9 5",
    d: "M100.632,33.875a7.411,7.411,0,0,1,6.2,3.064,20.275,20.275,0,0,1,3.026,7.258q3.612,14.807,4.014,15.39a1.787,1.787,0,0,1,.327.947,1.391,1.391,0,0,1-.475.986,4.246,4.246,0,0,1-2.406,1.02,10.517,10.517,0,0,1-1.679.147,4.011,4.011,0,0,1-3.684-1.679A35.6,35.6,0,0,1,101.87,50.36a81.186,81.186,0,0,1-1.895-9.154c0-.1.01-.158.036-.182q-1.06,1.533-2.846,4.559-1.9,3.136-2.808,4.486a24.3,24.3,0,0,1-7.367,7.476,7.946,7.946,0,0,1-4.012,1.386q-2.954,0-4.377-3.975-.657-1.86-1.531-10.5a23.19,23.19,0,0,1-.145-2.553c0-.339.01-.669.036-.984l.073-1.349V39.6a35.465,35.465,0,0,1-2.59,4.632Q70.47,50.833,68.9,52.4q-5.578,5.472-9.08,5.47-4.16,0-5.69-2.88a10.7,10.7,0,0,1-.949-4.959c0-.584.026-1.2.075-1.862q.073-1.309,1.093-8.058a34.87,34.87,0,0,0,.438-4.852,9.562,9.562,0,0,0-.145-1.824,1.708,1.708,0,0,1-.036-.364,1.831,1.831,0,0,1,.947-1.57,5.1,5.1,0,0,1,2.662-.693,6.709,6.709,0,0,1,2.955.62,2.891,2.891,0,0,1,1.677,2.006,13.517,13.517,0,0,1,.22,2.662,58.227,58.227,0,0,1-.913,8.9q-.182,1.167-.62,3.246a10.9,10.9,0,0,0-.327,1.858v.075q0,.182.109.182.364,0,2.369-2.992.73-1.094,2.153-3.719,1.53-2.845,2.369-4.159,3.1-4.924,6.347-6.163a8.733,8.733,0,0,1,3.064-.62,6,6,0,0,1,5.068,2.846,16.963,16.963,0,0,1,2.59,8.9q.073,1.46.073,2.59,0,3.1-.511,3.83,1.279-1.788,3.321-5.106,2.151-3.612,3.208-5.143Q96,33.874,100.632,33.875Z",
    transform: "translate(33.276 11.914)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_6",
    "data-name": "Trac\\xE9 6",
    d: "M97.026,29.447a17.422,17.422,0,0,1,5.179-.838,13.188,13.188,0,0,1,6.892,1.9q5.545,3.281,6.127,10.465c.05.681.075,1.363.075,2.042a21.62,21.62,0,0,1-4.121,12.73A20.99,20.99,0,0,1,98.45,64.35a19.986,19.986,0,0,1-4.559.584,9.643,9.643,0,0,1-7.076-2.626q-3.285-3.175-3.282-9.447V52.2a28.777,28.777,0,0,1,3.319-12.546q3.281-6.49,8.1-9.336a5.007,5.007,0,0,1,1.24-.62A2.833,2.833,0,0,1,97.026,29.447ZM103.7,53.7A16.278,16.278,0,0,0,107.13,44v-.62a15.155,15.155,0,0,0-1.279-6.529q-1.348-2.918-3.755-2.917a5,5,0,0,0-1.788.364q-3.354,1.533-5.836,6.019a24.992,24.992,0,0,0-2.771,8.1,28.591,28.591,0,0,0-.327,4.23A23.5,23.5,0,0,0,91.52,55.3q.548,4.266,2.953,4.268a2.937,2.937,0,0,0,.768-.111A14.558,14.558,0,0,0,103.7,53.7Z",
    transform: "translate(64.234 9.668)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_7",
    "data-name": "Trac\\xE9 7",
    d: "M104.38,28.1q.436-1.857,1.056-4.193.476-1.969.511-2.151a2.885,2.885,0,0,1,1.679-2.006,5.735,5.735,0,0,1,2.735-.62h.182a4.832,4.832,0,0,1,2.7.693,1.83,1.83,0,0,1,.949,1.567,1.857,1.857,0,0,1-.038.366,213.184,213.184,0,0,0-5.1,23.159q6.054-5.908,10.869-6.09h.618a16.4,16.4,0,0,1,9.009,2.66,8.368,8.368,0,0,1,4.23,7.332v.364q-.185,4.124-3.573,9.3-6.2,9.484-14.188,13.786a18,18,0,0,1-8.5,2.553,10.027,10.027,0,0,1-4.266-.911q-3.463-2.482-3.573-9.52v-.875a124.7,124.7,0,0,1,1.568-17.507Q102.886,34.667,104.38,28.1ZM108.1,54.908a18.778,18.778,0,0,0-.949,6.127q0,1.348.145,2.808.621,4.306,2.846,4.3a3.739,3.739,0,0,0,1.786-.547,29.572,29.572,0,0,0,7.258-6.127q5.69-7.111,5.688-11.744a6.227,6.227,0,0,0-.073-.984q-.473-3.539-2.88-4.414a4.613,4.613,0,0,0-1.531-.255,6.949,6.949,0,0,0-2.846.693,21.66,21.66,0,0,0-4.339,2.953A15.791,15.791,0,0,0,108.1,54.908Z",
    transform: "translate(80.699 0)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_8",
    "data-name": "Trac\\xE9 8",
    d: "M120.057,33.311a2.576,2.576,0,0,1,1.531-2.006,5.274,5.274,0,0,1,2.7-.656h.184a5.012,5.012,0,0,1,2.735.693,1.961,1.961,0,0,1,1.056,1.713v.257q-2.224,19.513-3.282,26.878a2.676,2.676,0,0,1-1.567,2.008,6.174,6.174,0,0,1-2.919.656,5.5,5.5,0,0,1-2.735-.693,1.92,1.92,0,0,1-1.02-1.642,1.381,1.381,0,0,1,.036-.329Q117.832,52.823,120.057,33.311Z",
    transform: "translate(98.102 11.749)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_9",
    "data-name": "Trac\\xE9 9",
    d: "M127.724,26.468a3.519,3.519,0,0,1-.071.693c-.026.17-.075.4-.147.693a4.616,4.616,0,0,1-.145.656q-.255,1.242-2.151,1.715a6.632,6.632,0,0,1-1.788.255,5.6,5.6,0,0,1-1.095-.109q-2.918-.548-2.917-2.553a4.135,4.135,0,0,1,.073-.729c.024-.17.061-.388.109-.656.075-.339.123-.56.145-.656q.255-1.239,2.153-1.749a7.408,7.408,0,0,1,1.749-.22,5.76,5.76,0,0,1,1.131.109Q127.725,24.427,127.724,26.468Z",
    transform: "translate(100.827 4.769)",
    fill: "#16acc8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(22.727 86.326)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M23.427,59.533l-1.8-7.08H22.6l.84,3.581c.21.883.4,1.765.525,2.448h.022c.115-.7.335-1.545.578-2.458l.945-3.571h.955l.861,3.591c.2.84.39,1.681.495,2.428h.02c.147-.778.347-1.565.568-2.448l.933-3.571h.935l-2.006,7.08h-.955l-.893-3.686a21.563,21.563,0,0,1-.463-2.311h-.02a22.591,22.591,0,0,1-.547,2.311l-1.008,3.686Z",
    transform: "translate(-21.631 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M32.4,56.214H29.651v2.551h3.066v.768H28.738v-7.08H32.56v.768H29.651v2.236H32.4Z",
    transform: "translate(-14.382 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M33.686,52.574a8.8,8.8,0,0,1,1.671-.147,2.92,2.92,0,0,1,1.943.515,1.483,1.483,0,0,1,.588,1.25,1.678,1.678,0,0,1-1.2,1.553v.022a1.823,1.823,0,0,1,1.458,1.774,1.9,1.9,0,0,1-.6,1.418,3.552,3.552,0,0,1-2.448.663,10.588,10.588,0,0,1-1.418-.085Zm.915,2.9h.83c.966,0,1.533-.5,1.533-1.188,0-.828-.63-1.153-1.555-1.153a3.864,3.864,0,0,0-.808.063Zm0,3.394a5.056,5.056,0,0,0,.766.04c.945,0,1.818-.345,1.818-1.376,0-.966-.83-1.365-1.828-1.365H34.6Z",
    transform: "translate(-9.335 -52.364)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M47.059,59.591c-.2-.2-.388-.4-.661-.693a2.911,2.911,0,0,1-2.07.808,2,2,0,0,1-2.173-1.986,2.325,2.325,0,0,1,1.386-2.068V55.62a2.425,2.425,0,0,1-.588-1.481,1.718,1.718,0,0,1,1.8-1.743,1.473,1.473,0,0,1,1.565,1.5c0,.745-.43,1.333-1.555,1.891v.03c.6.693,1.271,1.471,1.723,1.976a5.223,5.223,0,0,0,.683-2.07H48a5.388,5.388,0,0,1-1.018,2.616c.378.4.745.8,1.166,1.25Zm-1.113-1.218c-.42-.463-1.208-1.323-2-2.228a1.744,1.744,0,0,0-.913,1.44,1.4,1.4,0,0,0,1.448,1.428A1.976,1.976,0,0,0,45.946,58.373Zm-2.153-4.317a1.988,1.988,0,0,0,.535,1.271c.715-.41,1.178-.788,1.178-1.388a.834.834,0,0,0-.82-.913A.922.922,0,0,0,43.793,54.056Z",
    transform: "translate(-0.697 -52.396)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M57.48,56.424c-.053-.988-.115-2.175-.105-3.056h-.032c-.24.828-.535,1.711-.893,2.689L55.2,59.491h-.693l-1.145-3.371c-.337-1-.62-1.911-.82-2.751h-.02c-.022.881-.075,2.068-.137,3.129L52.2,59.533h-.873l.495-7.08h1.166l1.208,3.424c.293.873.535,1.65.713,2.386h.032c.178-.715.43-1.493.745-2.386l1.26-3.424H58.11l.44,7.08h-.893Z",
    transform: "translate(8.656 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M64.252,55.977c0,2.436-1.483,3.729-3.289,3.729-1.868,0-3.181-1.45-3.181-3.591,0-2.248,1.4-3.719,3.286-3.719C63,52.4,64.252,53.877,64.252,55.977Zm-5.494.115c0,1.513.82,2.868,2.258,2.868s2.268-1.335,2.268-2.941c0-1.408-.735-2.878-2.258-2.878S58.758,54.539,58.758,56.093Z",
    transform: "translate(15.242 -52.396)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M63.963,52.574a8.759,8.759,0,0,1,1.668-.147,2.92,2.92,0,0,1,1.943.515,1.485,1.485,0,0,1,.59,1.25,1.68,1.68,0,0,1-1.2,1.553v.022a1.822,1.822,0,0,1,1.46,1.774,1.9,1.9,0,0,1-.6,1.418,3.546,3.546,0,0,1-2.446.663,10.588,10.588,0,0,1-1.418-.085Zm.913,2.9h.83c.966,0,1.533-.5,1.533-1.188,0-.828-.63-1.153-1.555-1.153a3.879,3.879,0,0,0-.808.063Zm0,3.394a5.085,5.085,0,0,0,.768.04c.945,0,1.816-.345,1.816-1.376,0-.966-.83-1.365-1.828-1.365h-.755Z",
    transform: "translate(21.546 -52.364)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M70.085,52.453v7.08h-.913v-7.08Z",
    transform: "translate(26.859 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M72.806,52.453h.913v6.312h3.024v.768H72.806Z",
    transform: "translate(30.565 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_19",
    "data-name": "Trac\\xE9 19",
    d: "M81.315,56.214H78.564v2.551H81.63v.768H77.651v-7.08h3.822v.768H78.564v2.236h2.751Z",
    transform: "translate(35.507 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_20",
    "data-name": "Trac\\xE9 20",
    d: "M86.146,58.478a3.262,3.262,0,0,0,1.64.461c.933,0,1.481-.493,1.481-1.206,0-.663-.378-1.04-1.335-1.408-1.153-.41-1.868-1.008-1.868-2.008A2.038,2.038,0,0,1,88.352,52.4a3.2,3.2,0,0,1,1.565.347l-.253.745a2.8,2.8,0,0,0-1.343-.337c-.968,0-1.333.578-1.333,1.063,0,.661.43.986,1.406,1.365,1.2.461,1.806,1.038,1.806,2.079,0,1.093-.808,2.038-2.479,2.038a3.649,3.649,0,0,1-1.806-.452Z",
    transform: "translate(43.937 -52.396)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_21",
    "data-name": "Trac\\xE9 21",
    d: "M94.713,56.214H91.962v2.551h3.066v.768H91.047v-7.08h3.824v.768H91.962v2.236h2.751Z",
    transform: "translate(49.171 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_22",
    "data-name": "Trac\\xE9 22",
    d: "M96,52.574a9.491,9.491,0,0,1,1.753-.147A2.907,2.907,0,0,1,99.8,53a1.768,1.768,0,0,1,.556,1.345,1.858,1.858,0,0,1-1.333,1.806v.032a1.761,1.761,0,0,1,1.038,1.428,11.281,11.281,0,0,0,.547,1.943h-.945a9.283,9.283,0,0,1-.473-1.691c-.21-.978-.588-1.345-1.418-1.378h-.861v3.068H96Zm.915,3.224h.933c.978,0,1.6-.535,1.6-1.343,0-.915-.663-1.313-1.628-1.323a3.846,3.846,0,0,0-.9.083Z",
    transform: "translate(54.218 -52.364)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_23",
    "data-name": "Trac\\xE9 23",
    d: "M103.2,59.533l-2.311-7.08h.988l1.1,3.488c.3.955.568,1.816.755,2.646h.022c.2-.82.493-1.713.808-2.636l1.2-3.5h.976l-2.531,7.08Z",
    transform: "translate(59.213 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_24",
    "data-name": "Trac\\xE9 24",
    d: "M107.473,52.453v7.08h-.913v-7.08Z",
    transform: "translate(64.993 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_25",
    "data-name": "Trac\\xE9 25",
    d: "M115.353,59.359a4.517,4.517,0,0,1-1.87.337,3.307,3.307,0,0,1-3.5-3.581,3.523,3.523,0,0,1,3.7-3.719,3.816,3.816,0,0,1,1.681.315l-.22.745a3.341,3.341,0,0,0-1.43-.293,2.632,2.632,0,0,0-2.761,2.919,2.573,2.573,0,0,0,2.721,2.846,3.672,3.672,0,0,0,1.491-.293Z",
    transform: "translate(68.488 -52.396)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_26",
    "data-name": "Trac\\xE9 26",
    d: "M119.266,56.214h-2.753v2.551h3.068v.768H115.6v-7.08h3.824v.768h-2.911v2.236h2.753Z",
    transform: "translate(74.214 -52.338)",
    fill: "#666b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_27",
    "data-name": "Trac\\xE9 27",
    d: "M120.6,58.478a3.262,3.262,0,0,0,1.64.461c.933,0,1.481-.493,1.481-1.206,0-.663-.378-1.04-1.335-1.408-1.153-.41-1.868-1.008-1.868-2.008a2.038,2.038,0,0,1,2.289-1.921,3.2,3.2,0,0,1,1.565.347l-.252.745a2.8,2.8,0,0,0-1.343-.337c-.968,0-1.333.578-1.333,1.063,0,.661.43.986,1.406,1.365,1.2.461,1.808,1.038,1.808,2.079,0,1.093-.81,2.038-2.481,2.038a3.649,3.649,0,0,1-1.806-.452Z",
    transform: "translate(79.081 -52.396)",
    fill: "#666b71"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.fbe79547cb1ca7f16fc344e82e25b5de.svg";
export { ForwardRef as ReactComponent };